module.exports = __webpack_public_path__ + "img/advertising.b3f51219.png";